import React, { useState } from "react";
import {
  settingsAPI,
  settingsProxyAPI,
  useGetNylasStatusQuery,
} from "../../store/slices/settingsSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

export default function NylasStatus({
  CONNECTION_UUID,
  NYLAS_EMAIL,
}: {
  CONNECTION_UUID: string;
  NYLAS_EMAIL: string;
}) {
  const [pollingInterval, setPollingInterval] = useState(3000);
  const { data: nylasStatus } = useGetNylasStatusQuery(
    {
      CONNECTION_UUID,
      NYLAS_EMAIL,
    },
    { pollingInterval, skip: !CONNECTION_UUID || !NYLAS_EMAIL }
  );

  const dispatch = useDispatch();
  // Update polling interval based on status
  React.useEffect(() => {
    if (nylasStatus?.status === "connected") {
      setPollingInterval(0); // Stop polling when connected
      dispatch(settingsProxyAPI.util.invalidateTags(["ApiConnections"]));
    }
  }, [nylasStatus?.status]);

  return (
    <div>
      <div
        style={{ height: 500 }}
        className="d-flex justify-content-center align-items-center"
      >
        {nylasStatus?.status === "connected" && (
          <div className="rounded-3 py-4 mt-4 ps-4 pe-5 bg-purple-gradient-darker m-3 fw-bold row col-6">
            <span> Congrulations...</span>
            <div className="d-flex align-items-center">
              You are connected to Nylas with {NYLAS_EMAIL}
            </div>
            <Link to={`/library/api-connections/${CONNECTION_UUID}/details`}>
              Go back to details page.
            </Link>
          </div>
        )}

        {nylasStatus?.status === "connecting" && (
          <div className="rounded-3 py-4 mt-4 ps-4 pe-5 bg-purple-gradient-darker m-3 fw-bold row col-6">
            <span> Please wait...</span>
            <div className="d-flex align-items-center">
              You are connecting to Nylas with {NYLAS_EMAIL}
            </div>
            <div className="d-flex justify-content-center align-items-center mt-3">
              <FontAwesomeIcon icon={faSpinner} spin size="3x" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
